import { Card, CardContent, Grid, Tooltip } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";
import { dollarUS } from "../../../utilities/formatters";
import Title from "../../../components/ReusableComponents/title";
import "./Card.scss";

const Cards = ({ data }) => {
  const Clicks = (
    <Grid className="cardBox" item lg={3} sm={6} xs={6}>
      <Card style={{ background: "none", border: "none", boxShadow: "none" }}>
        <CardContent
        >
          <Typography
            sx={{ fontSize: 16, textAlign: "left" }}
            color="text.secondary"
            gutterBottom
          >
            Clicks
          </Typography>
          <div
            className="value_box d-flex"
          >
            <Typography variant="h5" component="div">
              {data ? data.pushed_leads : 0}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );

  const Pushleads = (
    <Grid className="cardBox" item lg={3} sm={6} xs={6}>
      <Card style={{ background: "none", border: "none", boxShadow: "none" }}>
        <CardContent
        >
          <Typography
            sx={{ fontSize: 16, textAlign: "left" }}
            color="text.secondary"
            gutterBottom
          >
            Sign ups
          </Typography>
          <div
            className="value_box d-flex"
          >
            <Typography variant="h5" component="div">
              {data ? data.signups : 0}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );

  const Conversions = (
    <Grid className="cardBox" item lg={3} sm={6} xs={6}>
      <Card style={{ background: "none", border: "none", boxShadow: "none" }}>
        <CardContent
        >
          <Typography
            sx={{ fontSize: 16, textAlign: "left" }}
            color="text.secondary"
            gutterBottom
          >
            Sales/Purchases
          </Typography>
          <div
            className="value_box d-flex"
          >
            <Typography variant="h5" component="div">
              {data ? data.conversions : 0}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );

  const Profit = (
    <Grid className="cardBox" item lg={3} sm={6} xs={6}>
      <Card style={{ background: "none", border: "none", boxShadow: "none" }}>
        <CardContent
        >
          <Typography
            sx={{ fontSize: 16, textAlign: "left" }}
            color="text.secondary"
            gutterBottom
          >
            Commission
            {/* <Tooltip
              enterTouchDelay={0}
              title={
                <React.Fragment>
                  <Title seven>
                    Total sum of commission available for payout.
                  </Title>
                </React.Fragment>
              }
            >
              <span
                style={{
                  color: "#1e88e5",
                  fontSize: "0.8rem",
                  margin: "0px 5px",
                }}
              >
                info
              </span>
            </Tooltip> */}
          </Typography>
          <div
            className="value_box d-flex"
          >
            <Typography variant="h5" component="div">
              {data ? dollarUS(data.outstanding_commission) : dollarUS(0)}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </Grid>
  );

  return (
    <Grid className="cardBoxContainer" container item spacing={2}>
      {Clicks}
      {Pushleads}
      {Conversions}
      {Profit}
    </Grid>
  );
};

export default Cards;
